/*
 * @Author: zhaihaooran
 * @Date: 2021-06-01 17:40:43
 * @LastEditors: OBKoro1
 * @FilePath: /umu_mobile/src/businessCommon/hooks/useGetWxJsConfig.ts
 */

import { useEffect } from 'react';
import { $window } from '@umu/umu-dom';
import { isWeChat, isWxWork } from '@umu/umu-ua';
import { getWxJsConfig as getConfig } from '@umu/umu-api';
import { WX_ENV } from '@umu/umu-types';

let isDebug = false;
isDebug = false;
const Cache: Map<string, wx.wxConfig> = new Map();

const wx = $window.wx;

const JS_API_LIST: wx.ApiMethod[] = [
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'chooseImage',
    'uploadImage',
    'downloadImage',
    'startRecord',
    'stopRecord',
    'onVoiceRecordEnd',
    'onVoicePlayEnd',
    'playVoice',
    'stopVoice',
    'pauseVoice',
    'uploadVoice'
];

function getUrl() {
    const href = $window.location.href;
    if (href.indexOf('#') > 0) {
        return href.substring(0, href.indexOf('#'));
    }
    return href;
}

export const getWxJsConfig = (href?: string) => {
    return new Promise((resolve: any, reject: any) => {
        if (!wx || !isWeChat) {
            resolve();
            return;
        }

        const url = href || getUrl();
        if (Cache.has(url)) {
            const existConfig = Cache.get(url);
            if (existConfig) {
                wx.config(existConfig);
            }
            resolve();
        } else {
            getConfig({
                url: encodeURIComponent(url),
                is_wx: isWxWork ? WX_ENV.WX_WORK : WX_ENV.WX,
            }).then(
                (result) => {
                    const config: wx.wxConfig = {
                        debug: isDebug,
                        appId: result.data.appid,
                        timestamp: result.data.timestamp,
                        nonceStr: result.data.noncestr,
                        signature: result.data.signature,
                        jsApiList: JS_API_LIST,
                    };
                    $window.wxAppid = result.data.appid;
                    wx.config(config);
                    Cache.set(url, config);
                    resolve('success');
                },
                () => {
                    reject('fail');
                },
            );
        }
    });
}

export const useGetWxJsConfig = (callback?: () => void, url?: string) => {
    useEffect(() => {
        getWxJsConfig(url).then(() => {
            if (callback) {
                callback();
            }
        });
    }, []);
};
